// @flow
import React, { Component, Fragment, useState } from "react";
import { Map } from "immutable";
import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { List } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

const styles = (theme) => ({
  list: {
    paddingLeft: theme.spacing(3),
  },
  nested: {
    paddingLeft: theme.spacing(5),
  },
  secondLevelNested: {
    color: "rgba(0, 0, 0, 0.7)",
    paddingLeft: theme.spacing(7.5),
    fontSize: "0.8rem",
  },
  text: { color: theme.palette.primary.main },
  icons: {
    fontSize: "20px",
    color: "gray",
  },
});

type Props = {
  pathname: string,
  classes: Object,
  item: Map<string, any> /*MenuItem*/,
  dispatch: (Object) => void,
};

type State = {
  open: boolean,
};

const SecondLevelNestedListItem = (props: {
  item: Map<string, any>,
  classes: Object,
}) => {
  const { item, classes } = props;

  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <ListItem
        button
        className={classes.nested}
        onClick={() => setOpen(!open)}
      >
        <ListItemText
          primary={
            <Typography variant="caption" color="textSecondary">
              {item.get("label")}
            </Typography>
          }
        />
        {open ? (
          <ExpandLess className={classes.icons} />
        ) : (
          <ExpandMore className={classes.icons} />
        )}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {item
            .get("children")
            .filter((nestedItem) => !Boolean(nestedItem.get("disabled")))
            .map((nestedItem, key) => {
              return (
                <ListItem
                  button
                  key={key}
                  component={nestedItem.get("to") ? Link : "li"}
                  onClick={(e) => {
                    // if onClick prop present and is a executable function, execute it!
                    if (
                      nestedItem.get("onClick") &&
                      typeof nestedItem.get("onClick") === "function"
                    ) {
                      nestedItem.get("onClick")();
                    }
                    // if Redux action object (must contain at least "type" attribute) is present, dispatch it
                    if (
                      nestedItem.getIn(["reduxAction", "type"]) !== undefined
                    ) {
                      dispatch(nestedItem.get("reduxAction").toJS());
                    }
                  }}
                  to={nestedItem.get("to") || null}
                  className={classes.secondLevelNested}
                >
                  {nestedItem.get("label")}
                </ListItem>
              );
            })}
        </List>
      </Collapse>
    </Fragment>
  );
};

class NestedListItem extends Component<Props, State> {
  state: State;

  constructor(props: Props) {
    super(props);
    this.state = { open: true };
  }

  handleClick = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { classes, item, pathname, dispatch } = this.props;
    return (
      <div>
        <ListItem className={classes.list} button onClick={this.handleClick}>
          <ListItemText
            disableTypography
            primary={
              <Typography variant="body2">{item.get("label")}</Typography>
            }
          />
          {this.state.open ? (
            <ExpandLess className={classes.icons} />
          ) : (
            <ExpandMore className={classes.icons} />
          )}
        </ListItem>
        {item.get("children") && (
          <Collapse in={this.state.open} timeout="auto" unmountOnExit>
            {item
              .get("children")
              .filter((value) => !Boolean(value.get("disabled")))
              .map((value, key) => {
                if (value.get("children") === undefined) {
                  return (
                    <ListItem
                      button
                      key={key}
                      component={value.get("to") ? Link : "li"}
                      onClick={(e) => {
                        // if onClick prop present and is a executable function, execute it!
                        if (
                          value.get("onClick") &&
                          typeof value.get("onClick") === "function"
                        ) {
                          value.get("onClick")();
                        }
                        // if Redux action object (must contain at least "type" attribute) is present, dispatch it
                        if (
                          value.getIn(["reduxAction", "type"]) !== undefined
                        ) {
                          dispatch(value.get("reduxAction").toJS());
                        }
                      }}
                      to={value.get("to") || null}
                      className={classes.nested}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            variant="caption"
                            className={
                              pathname === value.get("to") ? classes.text : ""
                            }
                            color="textSecondary"
                          >
                            {value.get("label")}
                          </Typography>
                        }
                      />
                    </ListItem>
                  );
                } else {
                  return (
                    <SecondLevelNestedListItem
                      key={key}
                      item={value}
                      classes={classes}
                    />
                  );
                }
              })}
          </Collapse>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(NestedListItem);
